import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { effectsApi } from 'services/api/remixer';
import { type AppDispatch } from 'services/store';
import { type Effects } from 'services/store/remixer/types';
import { createEffectsChain, GenericAudioContext } from '../audioHelpers';

const useCreateEffectsChain = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setIsLoading] = useState(false);

  const create = async (
    effects: Array<Effects>,
    audioContext: GenericAudioContext
  ) => {
    setIsLoading(true);

    const effectsDataPromises = effects.map(async (effectName) => {
      const promise = dispatch(
        effectsApi.endpoints.getEffect.initiate(effectName)
      );
      const patchData = await promise.unwrap();
      promise.unsubscribe();
      return {
        name: effectName,
        patchData,
      };
    });

    const effectsData = await Promise.all(effectsDataPromises);
    const chain = await createEffectsChain(effectsData, audioContext);

    setIsLoading(false);

    return chain;
  };

  return {
    create,
    isLoading,
  };
};

export default useCreateEffectsChain;
